export default "__VITE_ASSET__D5MCXdDA__"